export default {
  "content": "<g clip-path=\"url(#clip0_30_992)\" fill=\"#7B61FF\"><path d=\"M15.5 6h-11a1 1 0 00-1 1v10a1 1 0 001 1h15a1 1 0 001-1v-.5h2v.5a3 3 0 01-3 3h-15a3 3 0 01-3-3V7a3 3 0 013-3h11v2z\"/><path d=\"M21.757 2.868l.284.299a8 8 0 01-.284 11.015l-.525.525-1.414-1.415.525-.524a6 6 0 00.213-8.262l-.213-.224-.575-.575 1.414-1.414.575.575z\"/><path d=\"M18.586 5.696a4 4 0 010 5.658l-.354.353-1.414-1.414.354-.354a2 2 0 000-2.829l-.404-.403 1.414-1.414.404.403zM10.25 9a.25.25 0 01.25.25v2a.25.25 0 01-.25.25h-3a.25.25 0 01-.25-.25v-2A.25.25 0 017.25 9h3z\"/></g><defs><clipPath id=\"clip0_30_992\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};